<template>

<div class="spaces" :class="{'is-picking': isPicking}">

    <app-content-head v-if="isPicking" title="Pick slot" :inline-back="true" v-on:back="onCloseClick" subtitle="Use the visual picker to select a slot to volunteer.">

		<app-content-head-actions-item text="Undo" icon="undo" :disabled="!hasChanged" v-on:click="onUndoClick" />
		<app-content-head-actions-item text="Confirm" icon="tick" :disabled="!model.value || !hasChanged" v-on:click="onConfirmClick" />

    </app-content-head>

    <app-content-box class="spaces-box" :tabs="tabs" :not-padded="true" :forceTab="model.day">

        <template v-for="dayValue in roleDays" :slot="dayValue">

            <app-table class="spaces-table" :key="dayValue">

                <app-table-body>

                    <app-table-row :no-gap="true" :no-click="true" :no-hover="true" :layout="layout" key="times">

                        <app-table-cell-text text="Name" />
                        <app-table-cell-times :start="startTime" :end="endTime" :times="times" />
                        <app-table-cell-text text="Capacity" />

                    </app-table-row>

                    <app-table-row v-on:click="onSlotClick(slot.id)" :no-gap="true" v-tooltip="(slotOpen(slot)) ? 'Click to pick slot' : false" :no-click="!slotOpen(slot)" :layout="layout" v-for="slot in filteredSlots(dayValue)" :key="slot.id">
                        
                        <app-table-cell-text :text="slot.name" />
                        <app-table-cell-timeline :min="startTime" :max="endTime" :start="slot.start" :end="slot.start + slot.duration" :selected="model.value === slot.id" :times="times" :theme="(slotOpen(slot)) ? 'green' : 'red'" />
                        <app-table-cell-capacity :max="slot.capacity" :taken="(model.value === slot.id || !alreadySlotted(slot.id)) ? slot.taken : slot.taken - 1" :selected="model.value === slot.id && !alreadySlotted(slot.id)" :active="model.value === slot.id && alreadySlotted(slot.id)" />

                    </app-table-row>

                </app-table-body>

            </app-table>

        </template>

    </app-content-box>

</div>

</template>

<script>

import Vue from 'vue'

export default {

	props: ['days', 'role', 'slots', 'isPicking', 'assigned'],

	data: function() {

		return {
            model: {
                value: ''
            },
            original: {
                value: ''
            }
        }

    },

    computed: {

        hasChanged: function() {
        
            return !this.$_.isEqual(this.model, this.original)

        },

        layout: function() {
        
            return '240px 1fr 240px'

        },

        startTime: function() {

            return this.$_.min(this.slots, function(slot) {
            
                return slot.start
            
            }).start

        },

        endTime: function() {

            var end = this.$_.max(this.slots, function(slot) {
            
                return slot.start + slot.duration
            
            })

            return end.start + end.duration

        },

        tabs: function() {
        
            var tabs = []

            this.$_.each(this.roleDays, function(value) {
            
                tabs.push({
                    name: value,
                    text: this.days[parseInt(value)]
                })
            
            }.bind(this))

            return tabs

        },

        roleDays: function() {
		
			return this.role.days

		},

        times: function() {
		
			return this.$con.schedule.times

		}

    },

    created: function() {
    
        this.model.value = this.isPicking.value

        Vue.set(this, 'original', this.$util.copy(this.model))

        this.$pubsub.$emit('picker.opened')
                
    },

    watch: {
    
        isPicking: {
        
            deep: true,

            handler: function(n) {

                if(n) {

                    this.model.value = n.value
                
                    this.$pubsub.$emit('picker.opened')

                }
            
            }
        
        }

    },

    methods: {

        alreadySlotted: function(slot) {

            return this.$_.filter(this.assigned, function(assignment) {

                return assignment.slot.id === slot

            }).length

        },

        slotOpen: function(slot) {

            var slotStart = slot.start 
            var slotEnd = slot.start + slot.duration

            var overlaps = this.$_.filter(this.assigned, function(assignment) {

                var assignmentStart = assignment.slot.start
                var assignmentEnd = assignment.slot.start + assignment.slot.duration

                return assignment.slot.id === slot.id || (slotStart <= assignmentStart && slotEnd > assignmentEnd) || (slotStart < assignmentEnd && slotEnd >= assignmentEnd) || (slotStart >= assignmentStart && slotEnd <= assignmentEnd)

            })
        
            return !overlaps.length && slot.status === this.$constants.volunteers.slot.status.open

        },

        filteredSlots: function(dayValue) {
        
            return this.$_.where(this.slots, {
                day: parseInt(dayValue)    
            })

        },

        onSlotClick: function(value) {
        
            this.model.value = value

        },

        onUndoClick: function() {
        
            Vue.set(this, 'model', this.$util.copy(this.original))

        },

        onCloseClick: function() {

            this.$pubsub.$emit('picker.closed')

            this.$emit('close')

            this.model.value = false

        },

        onConfirmClick: function() {
        
            this.$pubsub.$emit('picker.confirmed', this.model)

            this.$emit('confirmed', this.model.value)

            this.onCloseClick()

        }
    
    }

}

</script>

<style scoped>

.spaces {
    user-select: none;
}

.spaces.is-picking {
    position: fixed;
    left: 320px;
    top: 80px;
    background-color: #fff;
    right: 0px;
    bottom: 0px;    
    overflow: auto;
    z-index: 100;
}

.is-mobile .spaces.is-picking,
.is-tablet .spaces.is-picking {
    left: 0px;
    top: 48px;
}

.spaces.is-picking .spaces-box {
    margin: 20px;
}

.spaces >>> .box-content {
    max-height: 600px;
    overflow: auto;
}

.spaces.is-picking >>> .box-content {
    max-height: 1000000px;
}

.spaces-table {
}

.spaces-table:last-child {
	margin-bottom: 0px;
}

.spaces-table >>> .body {
    padding: 0px!important;
}

.spaces-table >>> .row {
    padding-right: 0px;
}

</style>